import { sendRequestProtocols } from "../axios";
import isArray from "../plugins/isArray";

export default {
  state: {
    regions_re: [],
    phones_winners: [],
    emails_winners: [],
    contact_window_winners: false,
    window_customer: false,
    current_winner_id: "",
    current_winner_number: "",
    current_winner_lot: "",
    customer_name_re: "",
    cutomer_inn_re: "",
    title_re: "",
    protocolData: [],
    lastID: "",
    protocolDataTotal: 0
  },
  mutations: {
    SET_PROTOCOL_TOTAL(state, commit) {
      state.protocolDataTotal = commit;
    },
    SET_PROTOCOL_LAST_ID(state, commit) {
      state.lastID = commit;
    },
    SET_PROTOCOL_DATA(state, commit) {
      state.protocolData = commit;
    },
    SET_SHOW_WINNERS_CUSTOMER_WINDOW(state, commit) {
      state.window_customer = commit;
    },
    SET_CUSTOMER_INFO_INN(state, commit) {
      state.cutomer_inn_re = commit;
    },
    SET_CUSTOMER_INFO_NAME(state, commit) {
      state.customer_name_re = commit;
    },
    SET_CUSTOMER_INFO_TITLE(state, commit) {
      state.title_re = commit;
    },
    SET_CURRENT_WINNER_NUMBER_RE(state, commit) {
      state.current_winner_number = commit;
    },
    SET_CURRENT_WINNER_LOT_RE(state, commit) {
      state.current_winner_lot = commit;
    },
    SET_CURRENT_WINNER_RE(state, commit) {
      state.current_winner_id = commit;
    },
    SET_REGION_RE(state, commit) {
      state.regions_re = commit;
    },
    SET_PHONES_WINNERS(state, commit) {
      state.phones_winners = commit;
    },
    SET_EMAILS_WINNERS(state, commit) {
      state.emails_winners = commit;
    },
    SET_SHOW_WINNERS_CONTACT_WINDOW(state, commit) {
      state.contact_window_winners = commit;
    }
  },
  actions: {
    getProtocolData({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestProtocols("winnerRegistry", "post", data).then(
          response => {
            if(!response.data.protocols.data){
              commit("SET_PROTOCOL_DATA",[])
            }

            if (response.data.protocols.data && response.data.protocols.data.length) {
              commit("SET_PROTOCOL_DATA", response.data.protocols.data);
            }
            commit("SET_PROTOCOL_LAST_ID", response.data.lastID);
            commit("SET_PROTOCOL_TOTAL", response.data.total);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    getCustomerinfo({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestProtocols("getCustomerinfo/" + data, "post").then(
          response => {
            commit("SET_CUSTOMER_INFO_INN", response.data.customer_inn);
            commit("SET_CUSTOMER_INFO_NAME", response.data.customer_name);
            commit("SET_CUSTOMER_INFO_TITLE", response.data.title);

            commit("SET_CURRENT_WINNER_NUMBER_RE", response.data.number);
            commit("SET_CURRENT_WINNER_LOT_RE", response.data.lot);

            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    toggleWinnersCustomerWindow({ commit }) {
      commit("SET_SHOW_WINNERS_CUSTOMER_WINDOW", false);
      commit("SET_CUSTOMER_INFO_INN", "");
      commit("SET_CUSTOMER_INFO_NAME", "");
      commit("SET_CUSTOMER_INFO_TITLE", "");
    },
    toggleWinnersContactWindow({ commit }) {
      commit("SET_SHOW_WINNERS_CONTACT_WINDOW", false);
      commit("SET_CURRENT_WINNER_RE", "");
      commit("SET_CURRENT_WINNER_NUMBER_RE", "");
      commit("SET_CURRENT_WINNER_LOT_RE", "");
    },
    updateWinnerContacts({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestProtocols(
          "updateContacts",
          "post",
          data,
          reject
        ).then(response => {
          commit("SET_PHONES_WINNERS", response.data.phones);
          commit("SET_EMAILS_WINNERS", response.data.emails);
          // commit("SET_CURRENT_WINNER_RE", response.data.winner_inn);
          // commit("SET_CURRENT_WINNER_NUMBER_RE", response.data.number);
          // commit("SET_CURRENT_WINNER_LOT_RE", response.data.lot);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },

    getWinnersContacts({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequestProtocols(
          "winnersContacts",
          "post",
          data,
          reject
        ).then(response => {
          commit("SET_PHONES_WINNERS", response.data.phones);
          commit("SET_EMAILS_WINNERS", response.data.emails);
          commit("SET_CURRENT_WINNER_RE", data.winner_inn);
          commit("SET_CURRENT_WINNER_NUMBER_RE", data.number);
          commit("SET_CURRENT_WINNER_LOT_RE", data.lot);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    getRegionsRe({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);

        sendRequestProtocols("getRegionsRe", "get").then(response => {
          commit("SET_REGION_RE", response.data.regions);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    }
  },
  getters: {
    getRegionRe: state => state.regions_re,
    getEmailsWinners: state => state.emails_winners,
    getPhonesWinners: state => state.phones_winners,
    getWinnersContactWindow: state => state.contact_window_winners,
    getCurrentWinnerID: state => state.current_winner_id,
    getCurrentWinnerNumber: state => state.current_winner_number,
    getCurrentWinnerLot: state => state.current_winner_lot,
    getCustomerinfo_inn: state => state.cutomer_inn_re,
    getCustomerinfo_name: state => state.customer_name_re,
    getCustomerinfo_title: state => state.title_re,
    getShowCustomerWindow: state => state.window_customer,
    getProtocolData: state => state.protocolData,
    getProtocolLastID: state => state.lastID,
    getProtocolDataTotal: state => state.protocolDataTotal
  }
};
